module.exports = __webpack_public_path__ + "static/img/Apps4all-favicon.27be6f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons/Apps4all-favicon.png
// module id = 2531
// module chunks = 0